// extracted by mini-css-extract-plugin
export default {"container":"About_container__oTV1C","circleGroup":"About_circleGroup__oKql8","circlesBottom":"About_circlesBottom__F0fS2"};